import { startOfYear, subDays, subMonths, subYears } from 'date-fns';
import { StatementPeriodTypeOptions, PeriodPresetOptions } from '../types/client.enum';
import { StatementFormValues } from '../types/client.types';

export const getStartAndEndDate = (formValues: StatementFormValues): Date[] => {
  const today = new Date();
  if (formValues.statementPeriodType === StatementPeriodTypeOptions.toCurrentDate) {
    switch (formValues.periodPreset) {
      case PeriodPresetOptions.ninetyDays: {
        const startDate = getDateMinusDays(90);
        return [startDate, today];
      }
      case PeriodPresetOptions.oneYear: {
        const startDate = getDateMinusYears(1);
        return [startDate, today];
      }
      case PeriodPresetOptions.sinceInception: {
        const invInceptionDates = formValues.investments.map((inv) => inv.inceptionDate);
        const startDate = getEarliestDate(invInceptionDates);
        return [startDate, today];
      }
      case PeriodPresetOptions.thirtyDays:
      default: {
        const startDate = getDateMinusDays(30);
        return [startDate, today];
      }
    }
  }

  if (formValues.statementPeriodType === StatementPeriodTypeOptions.standardPeriods) {
    switch (formValues.periodPreset) {
      case PeriodPresetOptions.fiveYears: {
        const startDate = getDateMinusYears(5);
        return [startDate, today];
      }
      case PeriodPresetOptions.threeYears: {
        const startDate = getDateMinusYears(3);
        return [startDate, today];
      }
      case PeriodPresetOptions.oneYear: {
        const startDate = getDateMinusYears(1);
        return [startDate, today];
      }
      case PeriodPresetOptions.sixMonths: {
        const startDate = getDateMinusMonths(6);
        return [startDate, today];
      }
      case PeriodPresetOptions.yearToDate:
      default: {
        const startDate = getYearToDate();
        return [startDate, today];
      }
    }
  }

  if (formValues.statementPeriodType === StatementPeriodTypeOptions.customPeriod) {
    const startDate = formValues.dateRange[0];
    const endDate = formValues.dateRange[1];

    if (startDate && endDate) return [startDate, endDate];
  }

  const startDate = getDateMinusDays(30);
  return [startDate, today];
};

export const getDateMinusDays = (days: number): Date => {
  return subDays(new Date(), days);
};

const getDateMinusYears = (years: number): Date => {
  return subYears(new Date(), years);
};

const getDateMinusMonths = (months: number): Date => {
  return subMonths(new Date(), months);
};

const getYearToDate = (): Date => {
  return startOfYear(new Date());
};

const getEarliestDate = (dates: Date[]): Date => {
  return new Date(Math.min(...dates.map((date) => date.getTime())));
};
